import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '../../../../../../models/base/base-component';

@Component({
  selector: 'app-file-uploader-text',
  templateUrl: './file-uploader-text.component.html',
  styleUrls: ['./file-uploader-text.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileUploaderTextComponent extends BaseComponent {
  @Input() public disabled = false;
  @Input() public error = false;
  @Input() public descriptionText = '';
  @Input() public instructionText = $localize`Upload a file or drag and drop a .png, .jpeg or .pdf`;

  setupViews(): void {}
  setupBindings(): void {}
}
